module.exports = __webpack_public_path__ + "static/media/jetonlaode.6bb24ae1.png";